import { Box, styled, Typography } from '@mui/material';
import MuiAccordionSummary, {
    accordionSummaryClasses,
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { ReactComponent as ArrowRightIcon } from '../../../assets/icons/arrow-right-icon.svg';

export const CustomAccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary expandIcon={<ArrowRightIcon />} {...props} />
))(({ theme }) => ({
    height: 80,
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
        {
            transform: 'rotate(90deg)',
        },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
}));

export const CustomAccordionSummaryText = styled(Typography)({
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
});

export const CustomAccordionSummaryIcon = styled(Box)(({ theme }) => ({
    minWidth: 50,
    minHeight: 50,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
